import React, { createContext, useState, useContext, useEffect } from "react";
import axios from "axios";

const api = axios.create({
  headers: {
    Authorization: "Bearer vetri_kuralattam_XKokBfNWv6FIYuTMg5sLPjhJ",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET",
    "Access-Control-Allow-Headers": "Content-Type, Authorization",
  },
});

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    try {
      const response = await api.post("/api/login.php", {
        username: username,
        pass: password,
      });
      if (response.data && response.data.user) {
        const userData = response.data.user;
        console.log("User Data:", userData);
        setUser(userData);
        localStorage.setItem("user", JSON.stringify(userData));
        return { success: true };
      } else {
        return {
          success: false,
          error: response.data?.message || "Invalid credentials",
        };
      }
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data.error || "Server error. Please try again later.",
      };
    }
  };

  const register = async (username, password, name, school) => {
    try {
      const response = await fetch("/api/user1.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username,
          password,
          name,
          school,
          action: "register",
        }),
      });

      const data = await response.json();
      if (data.status === "success") {
        return { success: true };
      } else {
        return { success: false, error: data.message };
      }
    } catch (error) {
      console.error("Registration failed:", error);
      return {
        success: false,
        error: "Registration failed. Please try again.",
      };
    }
  };

  const changePassword = async (mobileno, currentPassword, newPassword) => {
    try {
      const response = await api.put("/api/user.php", {
        api: "changepassword",
        mobileno: mobileno,
        currentPassword: currentPassword,
        newPassword: newPassword,
      });

      if (response.data && response.data.message) {
        return { success: true };
      } else {
        return {
          success: false,
          error: response.data?.error || "Failed to change password",
        };
      }
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data.error || "Server error. Please try again later.",
      };
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("user");
    return { success: true };
  };

  const value = {
    user,
    loading,
    login,
    logout,
    register,
    changePassword,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === null) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
